import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/teams`;

export const teamsApi = {
  list: (orgId) => get(base(orgId)),
  stats: (orgId) => get(`${base(orgId)}/stats`),
  get: (orgId, teamId) => get(`${base(orgId)}/${teamId}`),
  create: (orgId, data) => post(base(orgId), data),
  update: (orgId, teamId, data) => patch(`${base(orgId)}/${teamId}`, data),
  remove: (orgId, teamId) => del(`${base(orgId)}/${teamId}`),
  addMember: (orgId, teamId, memberId) => post(`${base(orgId)}/${teamId}/members/${memberId}`),
  removeMember: (orgId, teamId, memberId) => del(`${base(orgId)}/${teamId}/members/${memberId}`),
  assignMembers: (orgId, teamId, memberIds) => post(`${base(orgId)}/${teamId}/members`, { memberIds }),
  assignWorkspaces: (orgId, teamId, workspaceIds) => post(`${base(orgId)}/${teamId}/workspaces`, { workspaceIds }),
};
